export const ACTIONS = {
  FIRST_LOAD: "FIRST_LOAD",
  PAGINATION: "PAGINATION",
  NEW_MESSAGE: "NEW_MESSAGE",
} as const;

export const MESSAGE_CONTAINER_ID = "scrollableMessagesDiv";
